import { modelTypes } from '@const/modelTypes';

const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/IndexPage.vue'),
      },
      {
        name: 'cases',
        path: 'cases',
        meta: { title: 'Cases' },
        component: () => import('pages/Cases.vue'),
      },
      {
        name: 'caseEdit',
        path: '/cases/edit/:id',
        component: () => import('pages/CaseEdit.vue'),
        props: (route) => ({
          id: route.params.id,
          tab: route.params.tab,
        }),
        children: [
          {
            name: 'caseEditTab',
            path: ':tab',
            component: () => import('pages/CaseEdit.vue'),
          },
        ],
      },
      {
        path: '/authorizations',
        meta: { title: 'Cases / Authorizations' },
        component: () => import('pages/Authorizations.vue'),
      },
      {
        name: 'claims',
        path: '/cases/claims',
        meta: { title: 'Claims' },
        component: () => import('pages/Claims.vue'),
      },
      {
        name: 'services',
        path: '/services',
        meta: { title: 'Claims services' },
        component: () => import('pages/ClaimsServices.vue'),
      },
      {
        name: 'providers',
        path: '/providers',
        meta: { title: 'Providers' },
        component: () => import('pages/Providers.vue'),
      },
      {
        name: 'providerEdit',
        path: '/providers/edit/:id',
        component: () => import('pages/ProviderFacilityEdit.vue'),
        props: (route) => ({
          modelType: modelTypes.PROVIDER,
          modelId: route.params.id,
          tab: route.params.tab,
        }),
        children: [
          {
            path: ':tab',
            component: () => import('pages/ProviderFacilityEdit.vue'),
          },
        ],
      },
      {
        name: 'facilities',
        path: '/facilities',
        meta: { title: 'Facilities' },
        component: () => import('pages/Facilities.vue'),
      },
      {
        name: 'facilityEdit',
        path: '/facilities/edit/:id',
        component: () => import('pages/ProviderFacilityEdit.vue'),
        props: (route) => ({
          modelType: modelTypes.FACILITY,
          modelId: route.params.id,
          tab: route.params.tab,
        }),
        children: [
          {
            path: ':tab',
            component: () => import('pages/ProviderFacilityEdit.vue'),
          },
        ],
      },
      {
        name: 'tasks',
        path: '/tasks',
        meta: { title: 'Tasks' },
        component: () => import('pages/Tasks.vue'),
      },
      {
        name: 'chats',
        path: '/chats',
        meta: { title: 'Chats' },
        component: () => import('pages/Chats.vue'),
        children: [
          {
            name: 'chat',
            path: ':chatId',
            component: () => import('pages/Chats.vue'),
            props: (route) => ({
              chatId: route.params.chatId,
            }),
          },
        ],
      },
      {
        name: 'users',
        path: '/admin/users',
        meta: { title: 'Admin / Users', requiresAdmin: true },
        component: () => import('pages/Users.vue'),
      },
      {
        name: 'userEdit',
        path: '/admin/users/edit/:id',
        meta: { title: 'Edit User' },
        component: () => import('pages/UserEdit.vue'),
        props: (route) => ({
          userId: route.params.id,
        }),
      },
      {
        name: 'cpts',
        path: '/admin/cpts',
        meta: { title: 'Admin / CPT Codes', requiresAdmin: true },
        component: () => import('pages/Cpts.vue'),
      },
      {
        path: '/admin/value-lists',
        meta: { title: 'Admin / Value Lists', requiresAdmin: true },
        component: () => import('pages/ValueLists.vue'),
      },
      {
        path: '/admin/rates',
        meta: { title: 'Admin / Rates' },
        component: () => import('pages/Rates.vue'),
      },
      {
        path: '/admin/formstack-forms',
        meta: { title: 'Admin / Formstack forms' },
        component: () => import('pages/FormstackForms.vue'),
      },
      {
        name: 'cmsPosts',
        path: '/admin/articles',
        meta: { title: 'Admin / CMS posts' },
        component: () => import('pages/CmsPosts.vue'),
      },
      {
        name: 'cmsPostEdit',
        path: '/admin/articles/:cmsPostId',
        component: () => import('pages/CmsPostEdit.vue'),
        props: (route) => ({
          cmsPostId: route.params.cmsPostId,
        }),
      },
      {
        path: '/admin/newsletters',
        meta: { title: 'Admin / Newsletters' },
        component: () => import('pages/Newsletters.vue'),
      },
      {
        path: '/admin/message-templates',
        meta: { title: 'Admin / Message Templates', requiresAdmin: true },
        component: () => import('pages/MessageTemplates.vue'),
      },
      {
        path: '/admin/settings',
        meta: { title: 'Admin / Settings', requiresAdmin: true },
        component: () => import('pages/Settings.vue'),
      },
      {
        path: '/otr-form',
        meta: { title: 'OTR form' },
        component: () => import('pages/OTRForm.vue'),
      },
      {
        name: 'forbidden',
        path: '/forbidden',
        component: () => import('pages/ForbiddenPage.vue'),
      },
      {
        name: 'companies',
        path: '/companies',
        meta: { title: 'Companies' },
        component: () => import('pages/Companies.vue'),
      },
      {
        name: 'companyEdit',
        path: '/companies/edit/:id',
        component: () => import('pages/CompanyEdit.vue'),
        props: (route) => ({
          companyId: route.params.id,
          tab: route.params.tab,
        }),
        children: [
          {
            path: ':tab',
            component: () => import('pages/CompanyEdit.vue'),
          },
        ],
      },
      {
        name: 'reporting',
        path: '/reporting',
        meta: { title: 'Reporting' },
        component: () => import('pages/Reports.vue'),
      },
      {
        name: 'otrs',
        path: '/otrs',
        meta: { title: 'OTRs' },
        component: () => import('pages/NotImplementedPage.vue'),
      },
      {
        path: '/authorizations',
        meta: { title: 'Authorizations' },
        component: () => import('pages/Authorizations'),
      },
      {
        name: 'profile',
        path: '/profile',
        meta: { title: 'Profile' },
        component: () => import('pages/Profile'),
      },
      {
        path: '/claims',
        meta: { title: 'Claims' },
        component: () => import('pages/Claims'),
      },
      {
        path: '/logs',
        meta: { title: 'Logs' },
        component: () => import('pages/Logs'),
        props: (route) => ({
          tab: route.params.tab,
        }),
        children: [
          {
            path: ':tab',
            component: () => import('pages/Logs.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    meta: { public: true },
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        name: 'login',
        path: '',
        meta: { public: true },
        component: () => import('pages/Login.vue'),
      },
    ],
  },
  {
    path: '/forgot-password',
    meta: { public: true },
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        name: 'forgot-password',
        path: '',
        meta: { public: true },
        component: () => import('pages/ForgotPassword.vue'),
      },
    ],
  },
  {
    path: '/reset-password',
    meta: { public: true },
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        name: 'reset-password',
        path: '',
        meta: { public: true },
        component: () => import('pages/ResetPassword.vue'),
      },
    ],
  },

  {
    path: '/client/reset-password',
    meta: { public: true },
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        name: 'client-reset-password',
        path: '',
        meta: { public: true },
        component: () => import('pages/ClientResetPassword.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('layouts/MainLayout.vue'),
    meta: {
      title: '404',
    },
    children: [
      {
        path: '',
        component: () => import('pages/Error404Page.vue'),
      },
    ],
  },
];

export default routes;
